module.exports = __webpack_public_path__ + "static/img/model2.5c339995.png";